import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { SignOutProps } from '../../types';

@inject('jwtStore')
@observer
class SignOut extends React.Component<SignOutProps> {
  public componentWillMount() {
    const { jwtStore, history } = this.props;

    localStorage.removeItem(jwtStore.localStorageKey);
    jwtStore.updateJwt();
    history.push('/');
  }

  public render() {
    return (<div/>);
  }
}

export default SignOut;



// WEBPACK FOOTER //
// ./src/pages/sign-out/index.tsx